import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, Output, TemplateRef, ViewChild } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { Store } from '@ngrx/store';
import * as L from 'leaflet';
import { icon, Marker } from 'leaflet';
import { BehaviorSubject } from 'rxjs';
import { State } from '../dave-data-module/State';
import { BaseActionTypes } from '../dave-data-module/State/actions/base.actions';
import { DaveLoadingModule } from '../dave-loading/dave-loading.module';
import { getImageDimensionsFromBase64 } from '../helper/helper';
import { SimpleMapScreenshoter } from 'leaflet-simple-map-screenshoter'

type tooltipOptions = {content: String|HTMLElement|Function, opacity?: number};
// function determineIfIsTooltipOptions(v: string | tooltipOptions): is tooltipOptions {
//
// }

require('leaflet.fullscreen')

const iconRetinaUrl = 'assets/leaflet/marker-icon-2x.png';
const iconUrl = 'assets/leaflet/marker-icon.png';
const shadowUrl = 'assets/leaflet/marker-shadow.png';
const iconDefault = icon({
    iconRetinaUrl,
    iconUrl,
    shadowUrl,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    tooltipAnchor: [16, -28],
    shadowSize: [41, 41],
});
const faLocationDotSvg =
    '<svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 0 384 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path fill="currentColor" d="M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"/></svg>';
const iconDefaultSvgOptions = {
    // iconRetinaUrl,
    // iconUrl,
    // shadowUrl,
    html: faLocationDotSvg,
    className: 'fa-icon-dot',
    iconSize: [36, 48],
    iconAnchor: [18, 48],
    popupAnchor: [1, -40],
    tooltipAnchor: [0, -40],
    shadowSize: [48, 48],
};
const iconDefaultSvg = L.divIcon(iconDefaultSvgOptions);
Marker.prototype.options.icon = iconDefaultSvg;

type marker = { _latlng: { lat: number; lng: number } };
type addMapMarkerOptions = { draggable?: boolean; icon?: any };
export type markerColor = 'red' | 'blue' | 'green' | '#fac600' | 'grey';


const  screenshotPluginOptions = {
    cropImageByInnerWH: true, // crop blank opacity from image borders
    // hidden: false, // hide screen icon
    preventDownload: true, // prevent download on button click
    // domtoimageOptions: {}, // see options for dom-to-image
    // position: 'topleft', // position of take screen icon
    // screenName: 'screen', // string or function
    // iconUrl: ICON_SVG_BASE64, // screen btn icon base64 or url
    // hideElementsWithSelectors: ['.leaflet-control-container'], // by default hide map controls All els must be child of _map._container
    // mimeType: 'image/png', // used if format == image,
    // caption: null, // string or function, added caption to bottom of screen
    // captionFontSize: 15,
    // captionFont: 'Arial',
    // captionColor: 'black',
    // captionBgColor: 'white',
    // captionOffset: 5,
    // callback for manually edit map if have warn: "May be map size very big on that zoom level, we have error"
    // and screenshot not created
    // onPixelDataFail: async function({ node, plugin, error, mapPane, domtoimageOptions }) {
    //     // Solutions:
    //     // decrease size of map
    //     // or decrease zoom level
    //     // or remove elements with big distanses
    //     // and after that return image in Promise - plugin._getPixelDataOfNormalMap
    //     console.log({ node, plugin, error, mapPane, domtoimageOptions })
    //     return plugin._getPixelDataOfNormalMap(domtoimageOptions)
    // }
}
@Component({
    selector: 'app-leaflet-wrapper',
    standalone: true,
    imports: [CommonModule, DaveLoadingModule, FontAwesomeModule],
    templateUrl: './leaflet-wrapper.component.html',
    styleUrls: ['./leaflet-wrapper.component.scss', '../../../node_modules/leaflet.fullscreen/Control.FullScreen.css'],
})
export class LeafletWrapperComponent implements AfterViewInit, OnDestroy {
    static nextId = 0;

    protected uniqId = 'app-leaflet-wrapper-' + LeafletWrapperComponent.nextId++;
    @Input() InitialDocument: { imageUrl: string /*imageBounds?: [[number, number], [number, number]]*/ };
    @Input() ScreenshotButton = false;
    @Output() MapInitialized = new EventEmitter<void>();
    @Output() MarkerAdded = new EventEmitter<marker>();
    @Output() MarkerMoved = new EventEmitter<marker>();
    @Output() ScreenshotTaken = new EventEmitter<Blob>()

    public MarkerTooltipsPermanent = false;
    public LeafletInstance: any;
    public screenshotter: SimpleMapScreenshoter;
    public AddMarkerMode = false;
    private AddMarkerModeContext: {
        color: markerColor;
        options: addMapMarkerOptions;
    };
    protected ngStyle = null;
    protected style = null;

    protected baseLayer = {
        background: null,
    };
    protected overlayLayer = {
        marker: L.layerGroup(),
    };
    private markerCache = [];

    protected loadBackgroundLayer$ = new BehaviorSubject(false);
    protected loadScreenshot$ = new BehaviorSubject(false);

    public OnDestroy$ = new EventEmitter<void>();
    @ViewChild('mapMarkerTemplate') mapMarkerTemplate: TemplateRef<any>;
    public static readonly MarkerCollerClassPrefix = 'marker-color-';

    constructor(private store: Store<State>) {}

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.initMap();
        }, 1);
    }
    ngOnDestroy(): void {
        this.OnDestroy$.emit();
        this.LeafletInstance.remove();
    }
    private initMap() {
        this.LeafletInstance = L.map(this.uniqId + '-map', {
            crs: L.CRS.Simple,
            minZoom: -5,
            fullscreenControl: true || document.fullscreenEnabled || (document as any).webkitFullscreenEnabled, // D277-4886 test fullscreen on all devices
            fullscreenControlOptions: {
                position: 'topleft'
            },
        })
            .addLayer(this.overlayLayer.marker)
            .on('click', (e) => {
                if (this.AddMarkerMode) {
                    this.addMarker(e.latlng.lat/this.imageHeight, e.latlng.lng/this.imageWidth, this.AddMarkerModeContext?.options, this.AddMarkerModeContext?.color);
                }
            });
        if (this.ScreenshotButton) {
            this.screenshotter = new SimpleMapScreenshoter(screenshotPluginOptions)

            // @ts-ignore
            this.screenshotter.addTo(this.LeafletInstance);

            this.LeafletInstance.on('simpleMapScreenshoter.click',  () => {
                console.log('simpleMapScreenshoter.click');
                this.loadScreenshot$.next(true);
                this.screenshotter.takeScreen('blob').then(image => {
                    console.log(image)
                    this.loadScreenshot$.next(false);
                    this.ScreenshotTaken.emit(image);
                }).catch(error => {
                    this.store.dispatch(BaseActionTypes.ErrorAction({Payload: {ToasterMessage: ''}}))
                    this.loadScreenshot$.next(false);
                })
            })

            this.LeafletInstance.on('simpleMapScreenshoter.done', function (event) {
                console.log('simpleMapScreenshoter.done', event)
            })

            console.log(this.screenshotter)
        }

        if (this.InitialDocument) {
            this.setBackground(
                this.InitialDocument.imageUrl,
            );
        }
        this.MapInitialized.emit();
    }
    private takeScreenShot = () => {
        console.log('takeScreenShot')
    }
    private log = (v) => {
        console.log('log', v)
    }
    public imageWidth: number;
    public imageHeight: number;

    public async setBackground(imageUrl: string): Promise<{ width: number; height: number }> {
        this.loadBackgroundLayer$.next(true);

        await getImageDimensionsFromBase64(this.InitialDocument.imageUrl).then((dimensions) => {
            // [90, 180],
            // [-90, -180],

            const ratio = dimensions.width / dimensions.heigth;
            const bigger = dimensions.width > dimensions.heigth ? dimensions.width : dimensions.heigth;
            const centerY = dimensions.heigth / 2;
            const centerX = dimensions.width / 2;
            this.imageWidth = dimensions.width;
            this.imageHeight = dimensions.heigth;
            this.baseLayer.background = L.imageOverlay(imageUrl, [
                [dimensions.heigth, 0],
                [0, dimensions.width],
            ]).addTo(this.LeafletInstance)
                .addTo(this.LeafletInstance)
                .on('load', () => {
                    this.loadBackgroundLayer$.next(false);
                })
                .on('error', () => {
                    this.loadBackgroundLayer$.next(false);
                    this.store.dispatch(BaseActionTypes.ErrorAction({ Payload: { ToasterMessage: 'Fehler beim Laden der Hintergrundkarte' } }));
                });

            this.LeafletInstance.setView([centerY, centerX], -1);

        });
        return { width: this.imageWidth, height: this.imageHeight };
    }
    public stopAddMarkerMode() {
        this.AddMarkerMode = false;
        const classList = document.querySelector('#' + this.uniqId + '-map')?.classList;
        classList?.forEach((className) => {
            if (className.startsWith('cursor-color-')) {
                classList.remove(className);
            }
        });
    }
    public startAddMarkerMode(options?: addMapMarkerOptions, color?: markerColor) {
        document.querySelector('#' + this.uniqId + '-map').classList.add('cursor-color-' + color);
        this.AddMarkerMode = true;
        this.AddMarkerModeContext = { options, color };
    }
    public clearMarkers() {
        this.overlayLayer.marker.clearLayers();
        this.markerCache = [];
    }
    public toggleMarkerTooltipsPermanent() {
        this.MarkerTooltipsPermanent = !this.MarkerTooltipsPermanent;
        this.markerCache.forEach(m => {
            this.reRenderTooltipFromMarter(m);
        });
    }
    private reRenderTooltipFromMarter(marker) {
        const t = marker.getTooltip();
        if (t) {
            const t2 = L.tooltip({...t.options, permanent: this.MarkerTooltipsPermanent})
            marker.unbindTooltip();
            marker.bindTooltip(t2);
        }
    }

    private waitForDimensions(timeoutMs = 5000): Promise<void> {
        return new Promise((resolve, reject) => {
            const start = Date.now();

            const check = () => {
                if (this.imageWidth && this.imageHeight) {
                    resolve();
                    return;
                }
                if (Date.now() - start > timeoutMs) {
                    reject(new Error('Timeout: image dimensions not available within ' + timeoutMs + 'ms'));
                    return;
                }
                setTimeout(check, 100);
            };

            check();
        });
    }

    public async addMarker(
        lat: number,
        lng: number,
        options?: addMapMarkerOptions,
        color?: markerColor,
        onClick?: (marker: marker, event: any) => void,
        tooltip?: string | tooltipOptions
    ) {
        try {
            await this.waitForDimensions();
        } catch (e) {
            console.error('addMarker aborted:', e);
            return;
        }
        const _options = {
            ...options,
            icon: L.divIcon({
                ...(options?.icon || iconDefaultSvgOptions),
                className: (options?.icon?.className ? options.icon.className : iconDefaultSvgOptions.className) + (color ? ' marker-color-' + color : ''),
            }),
        };

        const marker = L.marker([lat*this.imageHeight, lng*this.imageWidth], _options)
            .on('dragstart', () => {
                console.log('Marker drag started');
            })
            .on('drag', (event) => {
            })
            .on('dragend', (event) => {
                console.log('Marker drag ended', event.target.getLatLng());
                this.MarkerMoved.emit(event.target.getLatLng());
            });

        if (tooltip) {
            const config = typeof tooltip === 'string' ? { content: tooltip } : tooltip;
            const t = L.tooltip({
                direction: 'top',
                permanent: this.MarkerTooltipsPermanent,
                className: color ? 'colorful-marker-tooltip ' + LeafletWrapperComponent.MarkerCollerClassPrefix + color : '',
                ...config,
            });
            marker.bindTooltip(t);
        }

        if (onClick) {
            marker.on('click', (event) => {
                onClick(marker, event);
                this.reRenderTooltipFromMarter(marker); // Bugfix, wenn Tooltip verschwindet
            });
        }

        this.markerCache.push(marker);
        this.overlayLayer.marker.addLayer(marker);
        this.MarkerAdded.emit(marker);
    }

    public getMarker() {
        return this.overlayLayer.marker.getLayers();
    }
    public closeFullscreen() {
        if (this.LeafletInstance._isFullscreen) {
            this.LeafletInstance.toggleFullscreen();
        }
    }
}
